import { Flex, Text, Button } from "@chakra-ui/react";
import { DownvoteIcon } from "../icons/DownvoteIcon";
import { UpvoteIcon } from "../icons/UpvoteIcon";

interface CommentVoteButtonProps {
  toggleVote: (reactionTypeId: number) => void;
  userVoteType: number | null; // 9 for upvote, 10 for downvote, null for no vote
  upvoteCount: number;
  downvoteCount: number;
}

export function CommentVoteButton({
  toggleVote,
  userVoteType,
  upvoteCount,
  downvoteCount,
}: CommentVoteButtonProps) {
  const isUpvoted = userVoteType === 9;
  const isDownvoted = userVoteType === 10;
  const totalVotes = upvoteCount - downvoteCount;

  return (
    <Flex
      alignItems="center"
      gap="8px"
      height="30px"
      borderRadius="100px"
      background={
        isUpvoted || isDownvoted
          ? isUpvoted
            ? "transparent.blaze.50"
            : "transparent.info.50"
          : "transparent.white.10"
      }
      transition="all .1s linear"
    >
      <Button
        variant="iconOnly"
        size="xs"
        minW="auto"
        height="100%"
        onClick={() => toggleVote(9)}
        color="dune.dune"
        padding="4px 3px 4px 8px"
        borderRadius="100px 0px 0px 100px"
        fill={isUpvoted ? "dune.dune" : "transparent"}
        _hover={{
          color: isUpvoted ? "dune.300" : "blaze.400",
          background: isUpvoted
            ? "transparent.blaze.50"
            : "transparent.white.20",
        }}
      >
        <UpvoteIcon boxSize="18px" />
      </Button>

      <Text
        fontSize="12px"
        fontWeight="400"
        color="dune.dune"
        userSelect="none"
        textAlign="center"
      >
        {totalVotes}
      </Text>

      <Button
        variant="iconOnly"
        size="xs"
        minW="auto"
        height="100%"
        onClick={() => toggleVote(10)}
        color="dune.dune"
        padding="4px 8px 4px 3px"
        borderRadius="0px 100px 100px 0px"
        fill={isDownvoted ? "dune.dune" : "transparent"}
        _hover={{
          color: isDownvoted ? "dune.300" : "info.400",
          background: isDownvoted
            ? "transparent.info.50"
            : "transparent.white.20",
        }}
      >
        <DownvoteIcon boxSize="18px" />
      </Button>
    </Flex>
  );
}
